import React from 'react';
import { BookOpen, Gift, Plus } from 'lucide-react';
export function ContenidoIncluido() {
  return <section className="relative bg-[#1C1040] pt-4 md:pt-6 pb-2 md:pb-3 px-4 overflow-hidden" data-id="element-58" data-mp="1g8rcn40kucgq">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-59" data-mp="1b9ehzx3gs13l"></div>

      <div className="relative max-w-4xl mx-auto" data-id="element-60" data-mp="16d64eo4x0fyj">
        <h2 className="font-display font-bold text-white text-center text-lg md:text-2xl mb-3 md:mb-4" data-id="element-61" data-mp="23xk1kgis7k1u">
          📚 CONTENIDO INCLUIDO
        </h2>

        <div className="flex items-center justify-center gap-3 md:gap-6" data-id="element-62" data-mp="1z1uzo6jahr2d">
          <div className="flex flex-col items-center text-center max-w-[140px]" data-id="element-63" data-mp="1u6xrt2xqxnr2">
            <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-[#1a0533] to-[#0D0D1A] flex items-center justify-center text-gold mb-1.5 icon-glow" data-id="element-64" data-mp="1p8w9wlc23uh6">
              <div className="absolute inset-0 rounded-full border border-gold/30" data-id="element-65" data-mp="2hxbm703szyot"></div>
              <BookOpen className="w-5 h-5 md:w-6 md:h-6" data-id="element-66" data-mp="2834cjd7561iu" />
            </div>
            <h3 className="font-display font-bold text-white text-[13px] md:text-base mb-0.5 uppercase tracking-tight leading-tight" data-id="element-67" data-mp="2c4y7r5ykidbm">
              6 TOMOS
            </h3>
            <p className="text-white/60 text-[10px] md:text-xs leading-snug" data-id="element-68" data-mp="1ybgsvygttorx">
              Paso a paso para tener todo bajo control
            </p>
          </div>

          <div className="text-gold/60 shrink-0 -mt-6" data-id="element-69" data-mp="1oec6bxj2jral">
            <Plus className="w-4 h-4 md:w-5 md:h-5" strokeWidth={2.5} data-id="element-70" data-mp="1teglnk88qfz8" />
          </div>

          <div className="flex flex-col items-center text-center max-w-[140px]" data-id="element-71" data-mp="1tc3vwkw8r1bm">
            <div className="relative w-12 h-12 md:w-14 md:h-14 rounded-full bg-gradient-to-br from-[#1a0533] to-[#0D0D1A] flex items-center justify-center text-gold mb-1.5 icon-glow" data-id="element-72" data-mp="1fgjp2ntse9kk">
              <div className="absolute inset-0 rounded-full border border-gold/30" data-id="element-73" data-mp="39t9fgvky50n7"></div>
              <Gift className="w-5 h-5 md:w-6 md:h-6" data-id="element-74" data-mp="3eqi2pakybuvb" />
            </div>
            <h3 className="font-display font-bold text-white text-[13px] md:text-base mb-0.5 uppercase tracking-tight leading-tight" data-id="element-75" data-mp="3cdo0768t0gk8">
              5 BONOS
            </h3>
            <p className="text-white/60 text-[10px] md:text-xs leading-snug" data-id="element-76" data-mp="33cgcfi3wyy4e">
              Recursos extras que multiplican tus resultados
            </p>
          </div>
        </div>
      </div>
    </section>;
}